import React, { useState, useEffect } from "react";
import { ThemeProvider, Grid, CircularProgress, Box } from "@material-ui/core";
import theme from "./theme/theme";
import Header from "./components/Header/index";
import SearchBar from "./components/Searchbar/index";
import JobCard from "./components/Job/JobCard";
import JobModal from "./components/Job/JobModal";
import { firestore, app } from "./firebase/config";
const App = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [jobModal, setJobModal] = useState(false);
  const fetchJobs = async () => {
    setLoading(true);
    const req = await firestore
      .collection("Jobs")
      .orderBy("postedOn", "desc")
      .get();
    const tempJobs = req.docs.map((job) => ({
      ...job.data(),
      id: job.id,
      postedOn: job.data().postedOn.toDate()
    }));
    setJobs(tempJobs);
    setLoading(false);
  };
  const fetchJobsCustom = async (jobSearch) => {
    setLoading(true);
    const req = await firestore
      .collection("Jobs")
      .orderBy("postedOn", "desc")
      .where("location", "==", jobSearch.location)
      .where("type", "==", jobSearch.type)
      .get();
    const tempJobs = req.docs.map((job) => ({
      ...job.data(),
      id: job.id,
      postedOn: job.data().postedOn.toDate()
    }));
    setJobs(tempJobs);
    setLoading(false);
  };

  const postJob = async (jobDetails) => {
    await firestore.collection("Jobs").add({
      ...jobDetails,
      postedOn: app.firestore.FieldValue.serverTimestamp()
    });
    fetchJobs();
  };
  useEffect(() => {
    fetchJobs();
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <Header openJobModal={() => setJobModal(true)} />
      <JobModal
        closeJobModal={() => setJobModal(false)}
        jobModal={jobModal}
        postJob={postJob}
      />
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={10}>
          <SearchBar fetchJobsCustom={fetchJobsCustom} />
        </Grid>

        <Grid item xs={10}>
          {loading ? (
            <Box display="flex" justifyContent="center">
              <CircularProgress />
            </Box>
          ) : (
            jobs.map((job) => <JobCard key={job.id} {...job} />)
          )}
        </Grid>
      </Grid>
    </ThemeProvider>
  );
};

export default App;
